export enum ActorConversionMiscOutputName {
	BOOL = 'bool',
	FLOAT = 'float',
	INT = 'int',
}
